<!--
  ~ Copyright (c) Akveo 2019. All Rights Reserved.
  ~ Licensed under the Single Application / Multi Application License.
  ~ See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
  -->



<div class="row mcr">
  <div class="col-md-6 about">
    <div class="elip"></div>
    <div class="logo">
      <img src=".\assets\images\sulogo.png">
    </div>

    <h6 style="text-align: center;">Hello! Log in with your email.</h6>

    <div class="imge">
      <img src="./../../../../assets/images/Verified-rafiki.svg">
    </div>

    <div style="position: relative; ">
      <div style="position: absolute; z-index: 5; width: 100%;">
        <h5 style="text-align: center;">Don't have an account? <a style="color:DodgerBlue;" class="text-link" routerLink="../register">Register</a></h5>
      </div>
    </div>

  </div>
  
  <div class="col-md-6 form">
    <div [formGroup]="loginForm" aria-labelledby="title">

      <h1 id="title" class="title">Login</h1>

      <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
        <p class="alert-title"><b>Oh snap!</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
        </ul>
      </nb-alert>
      
      <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
        <p class="alert-title"><b>Hooray!</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
        </ul>
      </nb-alert>
      
      <nb-alert *ngIf="verify_message == true" outline="success" role="alert">
        <p class="alert-title"><b>Hooray!</b></p>
        <ul class="alert-message-list">
          <li class="alert-message">Your Email is verified. Kindly login now.</li>
        </ul>
      </nb-alert>

      <div class="form-control-group">
        <label for="input-email">Email address:</label>
        <input nbInput fullWidth id="input-email" formControlName="email"
          [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : ''"
          [attr.aria-invalid]="email.invalid && email.touched ? true : null" placeholder="Email address">
        <ngx-validation-message label="Email address" [showPattern]="email?.hasError('pattern') && email.touched"
          [showRequired]="email?.errors?.required && email.touched"></ngx-validation-message>
      </div>

      <div class="form-control-group">
        <span class="label-with-link">
          <label class="label" for="input-password">Password:</label>
        </span>
        <!-- <div style="position: relative; height: 48px;"> -->

          <div style="position: relative;">
            <input nbInput fullWidth id="input-password" formControlName="password"
              [type]="changetype ? 'password' : 'text'"
              [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : ''" placeholder="Password">
            <span style="position: absolute; top: 30%; cursor: pointer; right: 3%;" class="eyeicon" (click)="viewEye()"><i
                [ngClass]="viewEye ? 'fa fa-eye' : 'fa fa-eye-slash'"></i></span>
          </div>


        <ngx-validation-message label="Password" [showMinLength]="password?.hasError('minlength') && password.touched"
          [showMaxLength]="password?.hasError('maxlength') && password.touched"
          [showRequired]="password?.errors?.required && password.touched" [minLength]="minLength"
          [maxLength]="maxLength"></ngx-validation-message>
      </div>




      <div class="form-control-group accept-group">
        <nb-checkbox formControlName="rememberMe" name="rememberMe" *ngIf="rememberMe">Remember me</nb-checkbox>
        <a class="forgot-password caption-2" routerLink="../request-password">Forgot Password?</a>
      </div>

      <button nbButton fullWidth status="primary" size="large" (click)="login()"
        [disabled]="submitted || !loginForm.valid" [class.btn-pulse]="submitted">
        Log In
      </button>
    </div>

    <h6 class="login1">
      Don't have an account? <a class="text-link" routerLink="../register">Register</a>
    </h6>


    <section class="another-action" aria-label="Register">
      <!-- Are you an admin? <a class="text-link" routerLink="../registerAgent">Register as Admin</a> -->
    </section>
  </div>
</div>


<p-dialog [(visible)]="displayNo" [modal]="true" [responsive]="true" [style]="{width: '600px', minWidth: '700px'}"
  [minY]="70" [baseZIndex]="10000">

  <p-header>
    <h1>Duplicate Marksheet GENERAL INSTRUCTIONS </h1>
  </p-header>

  <p>1.Photo copy of Final year/Semester pass Marksheet.</p>

  <p>2. Photo copy of fee receipt of Convocation (If applied).</p>

  <p>3. Photo copy of Copy of Six Months/One Year Housemanship/Internship
    Completion Certificate issued by Solapur University (For Student of M.B.B.S., B.D.S.,
    B.P.O., B.O.T., B.Opto., B.H.M.S. Bachelor of Physiotherapy)</p>

  <p>4. Photo copy of Six Months/One Year practical training Certificate (For Student of
    B.Pharm/D.Pharm).</p>

  <p>5. Please read form carefully before submission.</p>

  <p>6. The prescribed fee of Rs. 436/- is paid online.</p>

  <p>7. The Certificate Will Be Valid only For Six Months From Date of Issue.</p>

  <p>8. Certificate will be ready by 15 working days. Collect Your Certificate Within One
    Month From Date of Submission of Document in University. Collect your Certificate
    with one month from date of Submission of Document in University.</p>

  <p>9. Students who have passed exam in April/May/June 1991 cannot apply for Provisional
    Degree Certificate. Such candidate should contact Convocation branch, Exam
    Section Room number 42 with Final Year Marksheet.</p>

  <p>10. All the regular students who have passed exams of
    BA/B.Com/B.Sc/BBA/BCA/B.Ed/ MA/M.Com/M.Sc between April/May 2011 to
    Nov/Dec 2017 cannot apply for Duplicate Marksheet
    . Such candidate
    should contact Convocation branch, Exam
    Section Room number 42 with Final Year Marksheet.</p>

  <p>11. If Degree is conferred as
    per our records then fees paid will not be refunded.</p>

</p-dialog>